import type { BreadcrumbMetadata, ErrorMetadata } from '@cbhq/error-vitals-web';

import { getErrorVitalsClient } from './errorVitals';

type LogMetadata = Partial<ErrorMetadata>;
type BreadcrumbData = Record<string, string | number | boolean | undefined | null>;

function getLoggableError(error: unknown): Error {
  if (error instanceof Error) {
    return error;
  }
  if (typeof error === 'string') {
    return new Error(error);
  }
  return new Error('Unsupported error format.', { cause: error });
}

export function logError(error: unknown, details?: LogMetadata): void {
  const client = getErrorVitalsClient();
  client?.logError(getLoggableError(error), {
    context: 'workspace',
    severity: 'error',
    isHandled: false,
    ...details,
  });
}

export function logWarning(warningMessage: string | Error, details?: LogMetadata): void {
  const client = getErrorVitalsClient();
  client?.logError(getLoggableError(warningMessage), {
    context: 'workspace',
    severity: 'warning',
    isHandled: false,
    ...details,
  });
}

export function logInfo(infoMessage: string, details?: BreadcrumbData): void {
  const client = getErrorVitalsClient();
  client?.addBreadcrumb(infoMessage, {
    type: 'log',
    context: 'workspace',
    ...details,
  } as BreadcrumbMetadata);
}
